import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import YtCardStatus from '@/components/yt-card-status'
import { isEmpty } from '@/utils/common'
import './noticePopover.scss'

export default {
    name: 'NoticePopover',

    components: {
        YtCardStatus
    },

    data() {
        return {
            visible: false
        }
    },

    computed: {
        ...mapState('notice', [
            'unreadNotice'
        ])
    },

    mounted() {
        this.fetchNotices({ iNoRead: 1 })
    },

    methods: {
        ...mapActions('notice', [
            'fetchNotices',
            'markNoticeReaded'
        ]),

        markRead() {
            if (this.unreadNotice.aList.length > 0) {
                this.markNoticeReaded()
                this.visible = false
            }
        },

        /**
         * 跳转到消息所在页面并展开对应的消息
         */
        toNoticePageItem(id) {
            const path = this.$route.path.substr(1)
            this.markNoticeReaded({ iAutoID: id })
            this.$router.push({
                path: '/notice',
                query: {
                    noticeId: id,
                    from: path
                }
            })
            this.visible = false
        },

        /**
         * 跳转消息列表页
         */
        toNoticePage() {
            const path = this.$route.path.substr(1)
            this.$router.push({
                path: '/notice',
                query: {
                    from: path
                }
            })
            this.visible = false
        },

        format(date) {
            return moment(date * 1000).format('YYYY.MM.DD HH:MM')
        }
    },

    render() {
        return (
            <el-popover
                v-model={this.visible}
                width='300'
                trigger='click'
                placement='bottom'
                popper-class='noticePopper_wrap'
            >
                <div slot='reference'>{this.$slots.reference}</div>
                <div class='notice-wrap'>
                    <div class='notice-list'>
                        {
                            (!isEmpty(this.unreadNotice) && this.unreadNotice.aList.length === 0) && <yt-card-status />
                        }

                        {
                            (!isEmpty(this.unreadNotice) && this.unreadNotice.aList.length > 0) && this.unreadNotice.aList.map(notice => (
                                <div class='list-item' onClick={() => this.toNoticePageItem(notice.iAutoID)}>
                                    <div class='icon'>
                                        <i class='iconfont iconsound-fill' />
                                    </div>
                                    <div class='content'>
                                        <div class='title'>{notice.aNoticeData.sTitle}</div>
                                        <div class='date'>{this.format(+notice.aNoticeData.iUpdateTime)}</div>
                                    </div>
                                    <div class='dot-wrap'>
                                        <i class='dot' />
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <div class='action'>
                        <div class='btn disabled' onClick={this.markRead}>全部已读</div>
                        <div class='btn' onClick={this.toNoticePage}>查看更多</div>
                    </div>
                </div>
            </el-popover>
        )
    }
}
